export default class ResetPasswordCtrl {

    // @ngInject
    constructor($location,
            config, vcRecaptchaService,
            responseHandler, authService) {
        this.$location = $location;
        this.responseHandler = responseHandler;
        this.authService = authService;
        this.invalidToken = -1 !== $location.path().indexOf('invalid-token');
        this.success = false;
        this.next_redirection = this.$location.$$search.next;
        this.data = {
            email: undefined,
            next: this.next_redirection
        };
        this.vcRecaptchaService = vcRecaptchaService;
        this.recaptcha_key = config.recaptchaPubKey;

        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render=6Lfwn_wgAAAAAEFmisC38nkGHJIB0kpkQTxEwjFF';
        script.id = 'recaptchaLibrary';
        document.body.appendChild(script);
    }

    submit() {
        const self = this;
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute('6Lfwn_wgAAAAAEFmisC38nkGHJIB0kpkQTxEwjFF').then((token) => {
                self.data.recaptcha_response = token;
                let promise = self.authService.resetPassword(self.data);
                self.responseHandler(promise, 'resetting your password')
                    .then(() => self.$location.path('/password/reset/confirmation'))
                    .finally(() => {
                        window.grecaptcha.reset('6Lfwn_wgAAAAAEFmisC38nkGHJIB0kpkQTxEwjFF');
                    });
            });
        });
    }

    recaptchaExpiration() {
        // eslint-disable-next-line no-undef
        window.grecaptcha.reset('6Lfwn_wgAAAAAEFmisC38nkGHJIB0kpkQTxEwjFF');
        this.response = null;
    }

    setRecaptchaResponse(response) {
        this.data.recaptcha_response = response;
    }
}



// WEBPACK FOOTER //
// ./password/reset/reset-password-ctrl.js